import React from 'react';
import Svg, { Defs, FeBlend, FeFlood, FeGaussianBlur, Filter, G, LinearGradient, Path, Stop } from 'react-native-svg';

import { ds } from '@/components/lib/design.system';
import { designSystem } from '@/styles/styles';

const SvgComponent = ({ width = 63, height = 200, ...props }) => {
    const color = props.color ?? ds.colorValue.icon.primary;
    return (
        <Svg width={width} height={height} viewBox="0 0 63 200" fill="none" {...props}>
            <Path opacity="0.05" d="M30.5 200L30.5 0" stroke="url(#paint0_linear_2328_498543)" />
            <G filter="url(#filter0_f_2328_498543)">
                <Path
                    d="M55.5 100C55.5 113.255 44.7548 124 31.5 124C18.2452 124 7.5 113.255 7.5 100C7.5 86.7452 18.2452 76 31.5 76C44.7548 76 55.5 86.7452 55.5 100Z"
                    fill={designSystem.colors.neutral800}
                />
            </G>
            <Path
                d="M36.6473 108C34.3707 108 32.2004 106.787 31.6898 105.596L32.477 100.809C33.2855 102.511 34.9664 104.213 36.6898 104.213C37.6047 104.213 38.0515 103.702 38.0515 103.128C38.0515 102.085 36.7111 101.83 35.243 100.83C33.9026 99.8936 32.9451 98.6383 32.9451 96.9149C32.9451 94.1489 35.3707 92 38.6473 92C41.1366 92 42.8388 93.2553 43.3494 93.9362L42.8813 98.4043C41.5622 96.7872 39.7962 95.7447 38.477 95.7447C37.6047 95.7447 37.2856 96.1915 37.2856 96.6383C37.2856 97.4681 38.4345 97.766 39.7962 98.6383C41.2005 99.5319 42.4132 100.787 42.4132 102.745C42.4132 105.617 39.86 108 36.6473 108Z"
                fill={color}
            />
            <Path
                d="M20.3511 107.723L18.5 92.2766H23.1383L23.9681 102.936L28.4149 92.2766H33.3298L26.0107 107.723H20.3511Z"
                fill={color}
            />
            <Defs>
                <Filter
                    id="filter0_f_2328_498543"
                    x="0.5"
                    y="69"
                    width="62"
                    height="62"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <FeFlood floodOpacity="0" result="BackgroundImageFix" />
                    <FeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                    <FeGaussianBlur stdDeviation="3.5" result="effect1_foregroundBlur_2328_498543" />
                </Filter>
                <LinearGradient
                    id="paint0_linear_2328_498543"
                    x1="30.4999"
                    y1="-1.92159e-06"
                    x2="30.5"
                    y2="200"
                    gradientUnits="userSpaceOnUse"
                >
                    <Stop stopColor={color} stopOpacity="0" />
                    <Stop offset="0.0980243" stopColor={color} />
                    <Stop offset="0.902736" stopColor={color} />
                    <Stop offset="1" stopColor={color} stopOpacity="0" />
                </LinearGradient>
            </Defs>
        </Svg>
    );
};

export default SvgComponent;
